import { useMemo } from "react";

import type { Rule } from "antd/es/form";
import { IntlShape } from "react-intl";

import { Person } from "@mapmycustomers/shared/types/entity";

import { MULTI_PERSON_LIMIT } from "./PersonRelationshipField";
import personRelationshipFieldMessages from "./personRelationshipFieldMessages";

const usePeopleFieldRules = (intl: IntlShape): Rule[] =>
  useMemo(
    () => [
      {
        validator: (_, value: Person["id"][] | undefined) => {
          if ((value?.length ?? 0) > MULTI_PERSON_LIMIT) {
            return Promise.reject(
              intl.formatMessage(personRelationshipFieldMessages.peopleLimitExceeded, {
                limit: MULTI_PERSON_LIMIT,
              })
            );
          }
          return Promise.resolve();
        },
      },
    ],
    [intl]
  );

export default usePeopleFieldRules;
